import React from "react";
import Youtube from "assets/youtube.svg";
import Instagram from "assets/instagram.svg";
import Twitter from "assets/twitter-x-logo.svg";
import Facebook from "assets/facebook.svg";
import Box from "ReusableComponents/Box";

const ShareIcons = ({ height = "30px", marginRight, marginTop, small }) => {
  return (
    <Box
      display="flex"
      // w="200px"
      justifyContent={small ? "start" : "space-between"}
      marginTop={marginTop}
    >
      <a
        href="https://www.facebook.com/EulerMotors"
        rel="noreferrer"
        target={"_blank"}
        style={{ marginRight }}
      >
        <img
          style={{ cursor: "pointer" }}
          src={Facebook}
          alt="Facebook"
          height={height}
        />
      </a>
      <a
        href="https://instagram.com/eulermotors"
        target={"_blank"}
        rel="noreferrer"
        style={{ marginRight }}
      >
        <img
          style={{ cursor: "pointer" }}
          src={Instagram}
          alt="Instagram"
          height={height}
        />
      </a>
      <a
        href="https://twitter.com/Euler_Motors"
        target={"_blank"}
        rel="noreferrer"
        style={{ marginRight }}
      >
        <img
          style={{ cursor: "pointer", background: '#99CEFB', borderRadius: '50%', padding: '8px' }}
          src={Twitter}
          alt="Twitter"
          height={height}
        />
      </a>
      <a
        href="https://www.youtube.com/c/EulerMotors"
        target={"_blank"}
        rel="noreferrer"
      >
        <img
          style={{ cursor: "pointer" }}
          src={Youtube}
          alt="Youtube"
          height={height}
        />
      </a>
    </Box>
  );
};

export default ShareIcons;
